module.exports = __webpack_public_path__ + "static/media/mei.8c1a4bc1.jpg";